import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// @mui
import { FormControl, FormLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { translateThis } from '../helpers/language.helper';
// components
import { register } from '../services/api/auth';
import { showSnackbar } from '../components/snackbar/index';
import TextInput from '../components/inputs/textInput/textInput';
import { isLoggedIn } from '../helpers/auth.helper';
import { authState } from '../state/auth.state';
import { USER_ROLES } from '../constants';
import { PasswordRequirementCheckBoxes } from '../components/inputs/textInput/password.requirements';





// ----------------------------------------------------------------------

export default function RegisterForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const isAuth = isLoggedIn();
    const auth = useAtomValue(authState);
    const { from } = location.state || { from: { pathname: `/` } };

    if (isAuth) {
        navigate(from, { replace: true });
    }
    // state variables for handling input fields values
    const [isLoading, setIsLoading] = useState(false);
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        userRole: auth.userRole,
        isTermsChecked: '',
        password: ''
    })
    const [validPassword, setValidPassword] = useState({
        eightCharacter: false,
        containNumber: false,
        containUpperCase: false,
        containSpecialChar: false
    });
    /**
   * sets the form data 
   * @param {string} name the name of the field
   * @param {string} value  the value of the field
   */
    const setFormValue = (name, value) => {
        setFormData({ ...formData, ...{ [name]: value } })

    }

    /**
     * Validates the form and returns true if valid
     * @returns boolean
     */
    const isValidForm = () => {
        let isValid = false;
        if (formData.userRole && formData.email && formData.password && formData.firstName && formData.lastName && isTermsChecked) {
            isValid = true;
        }
        return isValid;
    }

    /**
     * On submit the form
     */
    const onSubmit = () => {
        if (isValidForm()) {
            // Submitting data to backend for registration
            setIsLoading(true);
            const postData = {
                "role": formData.userRole,
                "email": formData.email,
                "password": formData.password,
                "firstName": `${formData.firstName}`,
                "lastName": `${formData.lastName}`
            }
            register(postData).then((data) => {
                if (data.success) {
                    navigate(from, { replace: true });
                    showSnackbar().success(data.message)
                } else {
                    showSnackbar().failure(data.message);
                }
            }).finally(() => setIsLoading(false));

        }

    };


    /**
    * To validate password requirement
    * @param {String} password 
    */
    const validatePassword = (password) => {
        const rules = {
            eightCharacter: false,
            containNumber: false,
            containUpperCase: false,
            containSpecialChar: false
        }

        if (password.length > 7) { // To check if password contain 8 chars
            rules.eightCharacter = true;
        }
        if (/\d/.test(password)) { // To check if password contain numbers
            rules.containNumber = true;
        }
        if (password !== password.toLowerCase()) { // To check if password contain uppercase
            rules.containUpperCase = true;
        }
        const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (format.test(password)) { // To check if password contain special chars
            rules.containSpecialChar = true;
        }
        setValidPassword(rules)
        if (rules.containNumber &&
            rules.containSpecialChar &&
            rules.containUpperCase &&
            rules.eightCharacter
        ) {
            setFormValue('password', password)
        } else {
            setFormValue('password', '')
        }
    }
    return (
        <>

            <Stack className='login-form register-form standard-form' spacing={3}>

                <div className='register-radio-btn'>
                    <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group">
                            <Typography variant="h3" fontStyle={'normal'} fontWeight={'300'}>{translateThis('Tell us who you are')}</Typography>
                        </FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={formData.userRole}
                            onChange={(e) => setFormValue('userRole', e.target.value)}
                        >
                            <FormControlLabel value={USER_ROLES.member} control={<Radio />} label={translateThis(USER_ROLES.member)} />
                            <FormControlLabel value={USER_ROLES.volunteer} control={<Radio />} label={translateThis(USER_ROLES.volunteer)} />
                        </RadioGroup>
                    </FormControl>
                </div>


                <div className='row'>
                    {/* <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                        <FormControl>
                            <FormLabel id="demo-controlled-radio-buttons-group"><Stack className='form-tile'>
                                <Typography variant="h3" fontStyle={'normal'} fontWeight={'300'}>{translateThis('Tell us who you are')}</Typography>
                            </Stack></FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={formData.userRole}
                                onChange={(e) => setFormValue('userRole', e.target.value)}
                            >
                                <FormControlLabel value={USER_ROLES.member} control={<Radio />} label={translateThis(USER_ROLES.member)} />
                                <FormControlLabel value={USER_ROLES.volunteer} control={<Radio />} label={translateThis(USER_ROLES.volunteer)} />
                            </RadioGroup>
                        </FormControl>
                    </div> */}

                    <div className='col-lg-6 col-md-12 col-sm-12 col-xs-12'>
                        <TextInput
                            key={`register_firstName`}
                            label={translateThis('firstName')}
                            name='firstName'
                            type='text'
                            isRequired
                            placeholder={translateThis('firstName')}
                            className='custom-textfield'
                            getValue={setFormValue}

                        />
                    </div>
                    <div className='col-lg-6 col-md-12 col-sm-12 col-xs-12'>
                        <TextInput
                            key={`register_lastName`}
                            label={translateThis('lastName')}
                            name='lastName'
                            type='text'
                            isRequired
                            placeholder={translateThis('lastName')}
                            className='custom-textfield'
                            getValue={setFormValue}

                        />
                    </div>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                        <TextInput
                            key={`register_email`}
                            label={translateThis('loginForm_email')}
                            name='email'
                            type='email'
                            isRequired
                            placeholder={translateThis('loginForm_emailPlaceHolder')}
                            className='custom-textfield'
                            getValue={setFormValue}

                        />
                    </div>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                        <TextInput
                            key={`register-password`}
                            label={translateThis('loginForm_password')}
                            name='register_password'
                            type='password'
                            isRequired={false}
                            placeholder={translateThis('loginForm_password')}
                            className='custom-textfield'
                            getValue={(_, value) => validatePassword(value)}

                        />
                    </div>

                </div>

                <PasswordRequirementCheckBoxes rules={validPassword} />
                <FormGroup className='custom-checkbox'>
                    <FormControlLabel control={<Checkbox checked={isTermsChecked} onChange={(e) => setIsTermsChecked(e.target.checked)} />} label={
                        <>{translateThis('regText_1')} <Link to={`/`}>{translateThis('regText_2')}</Link> {translateThis('regText_3')} <Link to={`/`}>{translateThis('regText_4')}</Link></>
                    } />
                </FormGroup>

                <LoadingButton
                    loading={isLoading}
                    loadingPosition='start'
                    startIcon={<></>} // To remove Mui warning
                    fullWidth
                    disabled={!isValidForm()}
                    size="large"
                    type="submit"
                    variant="contained"
                    className='standard-btn'
                    onClick={onSubmit}>
                    {translateThis('signUp')}
                </LoadingButton>
            </Stack>
            <Stack className='additional-btn' variant='div' spacing={3}>
                <p>{translateThis("alreadyHaveAnAccount")} <Link to={`/auth/login`}>{translateThis("loginButton")}</Link></p>
            </Stack>

        </>
    );
}
